<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.lstSchoolEventLangDTO"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Event Title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'lstSchoolEventLangDTO.' + index + '.eventTitle'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.eventTitle"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Description </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'lstSchoolEventLangDTO.' + index + '.description'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.description"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Location </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'lstSchoolEventLangDTO.' + index + '.location'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="langItem.location"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> ScopeType</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="scopeType"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="detailInfo.scopeType" name="scopeType">
                      <el-option
                        v-for="item in [
                          {
                            value: 1,
                            label: 'DISTRICT',
                          },
                          {
                            value: 2,
                            label: 'LEVEL',
                          },
                          {
                            value: 3,
                            label: 'SCHOOL',
                          },
                        ]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group" v-if="detailInfo.scopeType == 2">
                <label class="col-sm-2 control-label"> Level</label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="level"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="detailInfo.level" multiple name="level">
                      <el-option
                        v-for="item in [
                          {
                            value: 1,
                            label: 'PRIMARY',
                          },
                          {
                            value: 2,
                            label: 'SECONDARY',
                          },
                        ]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.scopeType == 3">
                <label class="col-sm-2 control-label"> Lst School Code</label>
                <div class="col-sm-4">
                  <div>
                    <el-form-item
                      prop="lstSchoolCode"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      }"
                    >
                      <el-select
                        v-model="detailInfo.lstSchoolCode"
                        clearable
                        multiple
                        name="lstSchoolCode"
                      >
                        <el-option
                          v-for="district in schoolCodeList"
                          :label="district.schoolCode"
                          :value="district.schoolCode"
                          :key="district.schoolCode"
                          class="ng-binding"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.scopeType == 1">
                <label class="col-sm-2 control-label"> Lst Distrit Code</label>
                <div class="col-sm-4">
                  <div>
                    <el-form-item
                      prop="lstDistritCode"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      }"
                    >
                      <el-select
                        v-model="detailInfo.lstDistritCode"
                        clearable
                        multiple
                        name="lstDistritCode"
                      >
                        <el-option
                          v-for="district in districtGetlist"
                          :label="district.schoolCode"
                          :value="district.districtNameEn"
                          :key="district.districtCode"
                          class="ng-binding"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Is AllYear Event </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="isAllYearEvent"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-switch
                      v-model="detailInfo.isAllYearEvent"
                      active-value="1"
                      inactive-value="0"
                    >
                    </el-switch>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.isAllYearEvent == 0">
                <label class="col-sm-2 control-label"> Start Event Date </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="startEventDate"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-date-picker
                      v-model="detailInfo.startEventDate"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.isAllYearEvent == 0">
                <label class="col-sm-2 control-label"> End Event Date </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="endEventDate"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-date-picker
                      v-model="detailInfo.endEventDate"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Start Publish Date
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="startPublishDate"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-date-picker
                      v-model="detailInfo.startPublishDate"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> End Publish Date </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="endPublishDate"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-date-picker
                      v-model="detailInfo.endPublishDate"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Event District </label>
                <div class="col-sm-4">
                  <el-form-item prop="eventDistrict">
                    <el-select
                      disabled=""
                      v-model="detailInfo.eventDistrict"
                      v-bind:placeholder="$t('message.PleaseSelect')"
                      name="eventDistrict"
                    >
                      <el-option
                        v-for="item in districtGetlist"
                        :key="item.districtCode"
                        :label="item.districtNameEn"
                        :value="item.districtCode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Ideas Category </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="ideasCategory"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select
                      v-model="detailInfo.ideasCategory"
                      clearable
                      name="ideasCategory"
                    >
                      <el-option
                        v-for="item in ['I', 'D', 'E', 'A', 'S']"
                        :label="item"
                        :value="item"
                        :key="item"
                        class="ng-binding"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Event Image </label>
                <div class="col-sm-10" style="display: flex">
                  <vuedraggable
                    v-model="detailInfo.lstSchoolEventImageDTO"
                    class="drag"
                  >
                    <transition-group>
                      <div
                        class="dragInfo"
                        v-for="item in detailInfo.lstSchoolEventImageDTO"
                        :key="item.eventImageUrl"
                      >
                        <el-image :src="item.eventImageThumbnailUrl"></el-image>
                        <i
                          class="el-icon-delete dragDelete"
                          @click="handleRemove(item)"
                        ></i>
                      </div>
                    </transition-group>
                  </vuedraggable>

                  <el-upload
                    action="#"
                    :http-request="uploadFile"
                    :file-list="detailInfo.lstSchoolEventImageDTO"
                    list-type="picture-card"
                    accept=".png, .jpg , .jpeg"
                    :auto-upload="true"
                    :show-file-list="false"
                  >
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.eventImageThumbnailUrl"
                        alt=""
                      />
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-delete"
                          @click="handleRemove(file)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      @click="checkEvent()"
                      v-if="
                        (checkPermission('SchoolEvent_LIST_EDIT') && $route.query.id) ||
                        (checkPermission('SchoolEvent_LIST_ADD') && !$route.query.id)
                      "
                      >Save</el-button
                    >
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import vuedraggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        ideasCategory: "",
        eventDistrict: "",
        startEventDate: "",
        endEventDate: "",
        startPublishDate: "",
        endPublishDate: "",
        isAllYearEvent: "",
        level: "",
        scopeType: "",
        lstDistritCode: [],
        lstSchoolCode: [],
        lstSchoolEventImageDTO: [],
        lstSchoolEventLangDTO: [],
      },
      schoolCodeList: [],
      districtGetlist: [],
      uploadErr:false
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  created() {
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title: "",
        description: "",
      });
    }
    this.$set(this.detailInfo, "lstSchoolEventLangDTO", obj);
    this.getSchoolCodeList();
    this.getDistrictGetlist();
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.schoolEventDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        data.data.result.isAllYearEvent =
          data.data.result.isAllYearEvent.toString();
        this.detailInfo = data.data.result;

        if (this.detailInfo.level == 0) {
          this.detailInfo.level = [1, 2];
        } else {
          this.detailInfo.level = [Number(this.detailInfo.level)];
        }

        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleRemove(file) {
      var index = "";
      this.detailInfo.lstSchoolEventImageDTO.forEach((item, i) => {
        if (item.eventImageUrl == file.eventImageUrl) {
          index = i;
        }
      });
      this.detailInfo.lstSchoolEventImageDTO.splice(index, 1);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    async getSchoolCodeList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.schoolCodeList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "schoolCodeList", data.data.result.schools);
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          obj[key] = this.detailInfo[key];
        }
        if (obj.level == [1, 2]) {
          obj.level = 0;
        } else {
          obj.level = obj.level[0];
        }
        var data;
        if (this.$route.query.id) {
          obj.userId = this.$store.state.userInfo.userId;
          obj.token = this.$store.state.userInfo.token;
          obj.id = this.$route.query.id;
          obj.apiUrl = this.apiConfig.schoolEventUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.userId = this.$store.state.userInfo.userId;
          obj.token = this.$store.state.userInfo.token;
          obj.apiUrl = this.apiConfig.schoolEventCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) {}
    },
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.detailInfo.lstSchoolEventImageDTO.push({
        eventImageUrl: data.data.result.url,
        eventImageThumbnailUrl: data.data.result.showUrl,
        fileType: 1,
        sortOrder: 1,
      });
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {},
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
  components: { vuedraggable },
};
</script>
